export default "__VITE_ASSET__CQB49IUD__"